(function () {
  if (window.__am2pmProductZoomInit) return;
  window.__am2pmProductZoomInit = true;

  var MEDIA = '.productView:not(.quickView) .productView-images-wrapper .productView-image .productView-img-container .media';
  var READY = 'data-am2pm-zoom-ready';
  var ACTIVE = 'is-am2pm-zoomed';

  function enabled() {
    return window.matchMedia('(min-width: 1025px) and (hover: hover) and (pointer: fine)').matches;
  }

  function sourceUrl(media) {
    var img = media.querySelector('img:not(.am2pm-zoom-layer)');
    return media.getAttribute('href') ||
      media.getAttribute('data-zoom-image') ||
      (img ? img.currentSrc || img.src : '');
  }

  function layerFor(media) {
    var url = sourceUrl(media);
    if (!url) return null;

    var layer = media.querySelector('.am2pm-zoom-layer');
    if (!layer) {
      layer = document.createElement('img');
      layer.className = 'am2pm-zoom-layer';
      layer.setAttribute('aria-hidden', 'true');
      layer.setAttribute('alt', '');
      media.appendChild(layer);
    }
    if (layer.getAttribute('data-src') !== url) {
      layer.setAttribute('data-src', url);
      layer.src = url;
    }
    return layer;
  }

  function move(media, event) {
    var layer = media.querySelector('.am2pm-zoom-layer');
    if (!layer) return;
    var rect = media.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    var x = Math.min(Math.max((event.clientX - rect.left) / rect.width, 0), 1);
    var y = Math.min(Math.max((event.clientY - rect.top) / rect.height, 0), 1);
    layer.style.transformOrigin = (x * 100) + '% ' + (y * 100) + '%';
  }

  function leave(media) {
    media.classList.remove(ACTIVE);
  }

  function activate(media, event) {
    if (media.classList.contains('has-video')) return;
    if (media.querySelector('.zoomImg')) return;
    if (!layerFor(media)) return;

    if (!media.hasAttribute(READY)) {
      media.setAttribute(READY, 'true');
      media.addEventListener('mousemove', function (e) { move(media, e); });
      media.addEventListener('mouseleave', function () { leave(media); });
    }

    move(media, event);
    media.classList.add(ACTIVE);
  }

  document.addEventListener('mouseover', function (e) {
    if (!enabled()) return;
    var target = e.target;
    if (!target || !target.closest) return;
    var media = target.closest(MEDIA);
    if (!media) return;
    activate(media, e);
  }, true);

  window.addEventListener('resize', function () {
    if (enabled()) return;
    var active = document.querySelectorAll('.media.' + ACTIVE);
    Array.prototype.forEach.call(active, leave);
  });
})();
